import * as Sentry from '@sentry/vue';
import posthog from 'posthog-js';

export default defineNuxtPlugin(({ vueApp }) => {
  const config = useRuntimeConfig();

  posthog.init(config.public.posthog.apiKey);

  Sentry.init({
    app: vueApp,
    dsn: config.public.sentry.dsn,
    enabled: !!config.public.sentry.environment,
    debug: config.public.sentry.environment !== 'prod',
    environment: config.public.sentry.environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      posthog.sentryIntegration({
        organization: config.public.sentry.organization,
        projectId: Number(config.public.sentry.projectId),
      }),
      Sentry.feedbackIntegration({
        // we will use email and name from Sentry.setUser
        showEmail: false,
        showName: false,
        formTitle: 'Give feedback',
        submitButtonLabel: 'Send feedback',
        enableScreenshot: false,
        autoInject: false,
        themeLight: {
          background: '#FAFAFA',
          foreground: '#171717',
          accentBackground: '#3F69FF',
          accentForeground: '#FAFAFA',
          successColor: '#00DC82',
          errorColor: '#FF6467',
        },
        themeDark: {
          background: '#171717',
          foreground: '#FAFAFA',
          accentBackground: '#94B8FF',
          accentForeground: '#171717',
          successColor: '#00C16A',
          errorColor: '#FB2C36',
        },
      }),
    ],
    tracesSampleRate: Number(config.public.sentry.traceSampleRate) ?? 0.1,
    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.category === 'ui.click') {
        const { target } = hint.event;

        if (!target) {
          return breadcrumb;
        }

        const id = target
          .closest('[data-ph-capture-attribute-id]')
          ?.getAttribute('data-ph-capture-attribute-id');

        if (id) {
          breadcrumb.message = id;
        }
      }
      return breadcrumb;
    },
  });

  Sentry.setTag('app', 'client');

  vueApp.mixin(
    Sentry.createTracingMixins({
      trackComponents: true,
      timeout: 2000,
      hooks: ['activate', 'mount', 'update'],
    }),
  );

  Sentry.attachErrorHandler(vueApp, {
    attachProps: true,
    attachErrorHandler: true,
    tracingOptions: {
      trackComponents: true,
      timeout: 2000,
      hooks: ['activate', 'mount', 'update'],
    },
  });

  return {
    provide: {
      sentryClientSide: Sentry,
    },
  };
});
